import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/tate_panda_logo.svg'
import _imports_1 from '../assets/atto_logo.svg'


const _hoisted_1 = { class: "row ccm00100-login" }
const _hoisted_2 = { class: "col sheet" }
const _hoisted_3 = { class: "column justify-center items-center ccm00100-form-card" }
const _hoisted_4 = {
  class: "col",
  style: {"width":"100%"}
}
const _hoisted_5 = {
  class: "col",
  style: {"width":"100%"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }

import { ref } from 'vue';
import Loading from 'quasar/src/plugins/Loading.js';;
import { useRoute } from 'vue-router';
import MessageChip from '../components/chip/MessageChip.vue';
import NewsAreaScroll from '../components/scroll/NewsAreaScroll.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CCM00100',
  setup(__props) {

const route = useRoute();
// cookie
const cookies = document.cookie;
// CSRFトークン
let cookiesArray = cookies.split(';');
cookiesArray = cookiesArray[0].split('=');
const csrfToken = cookiesArray[1];
// メールアドレス
const mail_address = ref('');
// パスワード
const password = ref('');
// パスワードマスキングフラグ
const isPwd = ref(true);
// MessageChip表示フラグ
const isMessageChip = ref(false);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  Loading.hide();
  isMessageChip.value = false;
};

/**
 * 初期表示
 */
if (!!route.query.error || !!route.query.timeout) {
  isMessageChip.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col sheet primary" }, [
      _createElementVNode("div", { class: "col ccm00100-caption column justify-end text-white" }, [
        _createElementVNode("div", { class: "vertical-logo-area logo" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ]),
        _createElementVNode("p", null, "◎ ChemPandaのご利用にあたり、費用のご負担は一切ありません。"),
        _createElementVNode("p", null, " ◎ ChemPandaには、全世界のサプライヤ約350社の製品データとして、試薬及びバルク製品（電子材料、農薬原料、化粧品原料、塗料・インキ・接着剤、天然物、機能性材料、医薬品中間体、原薬（API））が登録されており、幅広く自由に検索できます。 "),
        _createElementVNode("p", null, " ◎ 試薬（在庫品・カスタム合成品）は、グローバルなサプライヤの製品をニーズに応じて検索できます。 "),
        _createElementVNode("p", null, "◎ バルク製品は、中国の現地サプライヤ が展開する多様な製品を網羅しています。"),
        _createElementVNode("p", null, "◎ 構造式検索のほか、キー検索、リスト検索が可能です。"),
        _createElementVNode("p", null, "◎ 検索結果より御見積書の発行やご注文ができます。")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MessageChip, {
          display: isMessageChip.value,
          level: "E",
          message: !!_ctx.$route.query.error ? _ctx.$t('message.MSG_50001E') : _ctx.$t('message.MSG_50002E')
        }, null, 8, ["display", "message"]),
        _createVNode(_component_q_card, {
          bordered: "",
          flat: "",
          class: "bg-grey-2",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "column justify-center items-center q-gutter-y-md" }, {
              default: _withCtx(() => [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "customer-logo" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: ""
                  })
                ], -1)),
                _createVNode(_component_q_form, {
                  id: "loginForm",
                  ref: "loginForm",
                  action: "/login",
                  method: "post",
                  class: "column justify-center items-center q-gutter-xs",
                  style: {"width":"70%"},
                  novalidate: "",
                  autocomplete: "off",
                  greedy: "",
                  onValidationError: resetError
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_input, {
                      id: "_csrf",
                      modelValue: _unref(csrfToken),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(csrfToken) ? (csrfToken).value = $event : null)),
                      style: {"display":"none"},
                      name: "_csrf"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_4, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", null, "会員ID（メールアドレス）", -1)),
                      _createVNode(_component_q_input, {
                        id: "mail_address",
                        modelValue: mail_address.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mail_address).value = $event)),
                        outlined: "",
                        name: "mail_address",
                        dense: "",
                        rules: [(val) => !!val || _ctx.$t('validation.required')],
                        "lazy-rules": "",
                        type: "email",
                        "bg-color": "white",
                        maxlength: "254",
                        autofocus: "",
                        class: "input-area"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", null, "パスワード", -1)),
                      _createVNode(_component_q_input, {
                        id: "password",
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
                        outlined: "",
                        name: "password",
                        dense: "",
                        rules: [(val) => !!val || _ctx.$t('validation.required')],
                        type: isPwd.value ? 'password' : 'text',
                        "bg-color": "white",
                        maxlength: "72",
                        class: "input-area left-input"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: isPwd.value ? 'visibility_off' : 'visibility',
                            class: "cursor-pointer",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (isPwd.value = !isPwd.value))
                          }, null, 8, ["name"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "rules", "type"])
                    ]),
                    _createVNode(_component_q_btn, {
                      label: "ログイン",
                      type: "submit",
                      style: {"width":"200px"},
                      color: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(Loading).show()))
                    })
                  ]),
                  _: 1
                }, 512),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: { name: 'passwordReissue', params: { isLogin: '0' } },
                    class: "text-link"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" ログインできない場合はこちら ")
                    ])),
                    _: 1
                  })
                ]),
                _createVNode(_component_q_separator, {
                  class: "ccm00100-separator",
                  style: {"width":"100%"}
                }),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_q_btn, {
                    label: "新規会員登録",
                    outline: "",
                    color: "primary",
                    style: {"width":"200px","background":"var(--q-white) !important"},
                    to: { name: 'memberRegist', params: { isLogin: '0' } }
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(NewsAreaScroll, { "display-screen": "0" })
    ])
  ]))
}
}

})